import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { getToggleOptions } from './helpers';
import { opButtons, tabContainerIds } from './constants';
import { OperationalParametersHeader } from './OperationalParametersHeader';
import { DownloadMeasurements } from '../Header/DownloadMeasurements';

import './style.scss';

const OperationalParametersComponent = ({
    model: {
        activeTab,
        multiChart,
        measurementDownloadDialogParams
    },
    asset,
    actions,
    isUnmonitored
}) => {
    // if we need newcapability service then change to useNewCapability shared hook
    const toggleOptions = getToggleOptions(multiChart, isUnmonitored);

    const closeDownloadMeasurement = () => {
        actions.clearDownloadMeasurementStore();
    };

    const tabComponent = toggleOptions?.find((opt) => opt.value === activeTab);

    return toggleOptions.length ?
        <Container fluid id='operational-parameters-container'>
            <OperationalParametersHeader toggleOptions={toggleOptions} />
            <DownloadMeasurements
                show={measurementDownloadDialogParams?.measurementTypeIds?.length > 0}
                close={() => closeDownloadMeasurement()} />
            <Row className='operational-parameter-tab-chart-row'>
                <Col md={12} className={`operational-parameter-tab-container ${activeTab === opButtons.vibrationFFTV2 ? 'parent-height' : ''}`}>
                    {/* {
                        map(toggleOptions, (opt) => {
                            return <div key={opt.value} style={{ display: opt.value === activeTab ? null : 'none' }} id={tabContainerIds[opt.value]}>
                                <opt.component activeTab={activeTab} asset={asset} multiChart={multiChart} />
                            </div>;
                        })
                    } */}
                    {tabComponent && <div id={tabContainerIds[tabComponent.value]}>
                        <tabComponent.component activeTab={activeTab} asset={asset} multiChart={multiChart} />
                    </div>}
                </Col>
            </Row>
        </Container> : null;
};

OperationalParametersComponent.propTypes = {
    model: PropTypes.shape({
        activeTab: PropTypes.string,
        multiChart: PropTypes.string,
        measurementDownloadDialogParams: PropTypes.shape({
            measurementTypeIds: PropTypes.arrayOf(PropTypes.string),
        }),
    }),
    asset: PropTypes.object,
    actions: PropTypes.shape({
        clearDownloadMeasurementStore: PropTypes.func,
    }),
    isUnmonitored: PropTypes.bool,
};

export default OperationalParametersComponent;
